<template>
	<div class="carregando" style="display: inline">
		<spinner />
	</div>
</template>

<script>
export default {}
</script>
